import * as fromActions from './init-user.actions';
import { UserModel } from '@app/models/server/user.model';
import { createReducer, on } from '@ngrx/store';

export interface UserState {
  entity: UserModel;
  _id: string;
  loading: boolean;
  error: string;
  clientData: {
    mobileNo: string;
    displayName: string;
    email: string;
  };
}

const initialState: UserState = {
  entity: null,
  _id: null,
  loading: null,
  error: null,
  clientData: null,
};

export const reducer = createReducer(
  initialState,
  on(fromActions.INIT, (state, payload: {}) => ({
    ...state,
    loading: false,
  })),
  on(
    fromActions.InitAuthorized,
    (
      state,
      payload: {
        _id: string;
        user: UserModel;
      }
    ) => ({
      ...state,
      loading: false,
      entity: payload.user,
      uid: payload._id,
      error: null,
    })
  ),
  on(fromActions.InitUnAuthorized, (state, payload: {}) => ({
    ...state,
    loading: true,
  })),
  on(
    fromActions.InitError,
    (
      state,
      payload: {
        error: string;
      }
    ) => ({
      ...state,
      loading: false,
      error: payload.error,
    })
  ),
  on(fromActions.SignOut, (state, payload: {}) => ({
    ...state,
    loading: false,
  })),
  on(fromActions.SignOutSuccess, (state) => ({
    ...state,
    loading: false,
    entity: null,
    uid: null,
    error: null,
  })),
  on(fromActions.SignOutError, (state, payload: {}) => ({
    ...state,
    loading: false,
    entity: null,
    uid: null,
    error: null,
  }))
);
